import React from 'react';

import { twMerge } from 'tailwind-merge';

import { InternalLink } from '../../../../../../Clickables/InternalLink/InternalLink';
import { ChevronRightIcon } from '../../../../../../Icons/ChevronRightIcon';
import { Text } from '../../../../../../Text/Text';

interface CatchDetailsRowProps {
  className?: string;
  detailName: string;
  detailValue: string;
  to?: string;
}

export const CatchDetailsRow = ({
  detailName,
  detailValue,
  className,
  to,
}: CatchDetailsRowProps) => {
  return (
    <tr className={twMerge('relative flex px-4 py-2', className)}>
      <td className="text-midnight w-[130px] p-0 font-normal">
        <Text className="mb-0" variant="sm">
          {detailName}
        </Text>
      </td>
      <td className="p-0 font-semibold">
        <Text className="mb-0" variant="sm">
          {detailValue}
        </Text>
      </td>
      {to && (
        <td className="absolute top-[50%] right-[5.5px] -translate-y-[50%] p-0">
          <InternalLink to={to}>
            <ChevronRightIcon />
          </InternalLink>
        </td>
      )}
    </tr>
  );
};
